import { ApolloError } from '@apollo/client';

interface NetworkError extends Error {
  status: number;
  statusText: string;
  response: string;
  responseText: string;
}

function isNetworkError(error: any): error is NetworkError {
  return error && error.xhr;
}

export function getErrorStatusCode(crmError?: ApolloError | Error) {
  const networkError =
    crmError && 'networkError' in crmError ? crmError.networkError : undefined;

  if (!networkError || !isNetworkError(networkError)) {
    return undefined;
  }

  return networkError.status;
}
